import Backbone from 'backbone';
import { BackboneViewProps } from '../../types';

const $ = require('jquery');
const template = require('./intercom.pug');

function highlight(subclass: string) {
  $('.sidebar__nav *').removeClass('active');
  $(`li.sidebar__nav--${subclass}`).addClass('active');
}

export default (Backbone as any).Epoxy.View.extend({
  events: {
    'click #go-integrations': 'go_integrations',
    'click #go-profiles': 'go_profiles',
    'click #go-predictions': 'go_predictions',
  },

  go_integrations() {
    highlight('integrations');
    Backbone.history.navigate(
      `/org/${this.tenant}/integrations/list/all`,
      true
    );
  },
  go_predictions() {
    highlight('predictions');
    Backbone.history.navigate(`/org/${this.tenant}/predictions`, true);
  },
  go_profiles() {
    highlight('profiles');
    Backbone.history.navigate(`/org/${this.tenant}/profiles`, true);
  },

  async initialize(paramOptions: BackboneViewProps) {
    const options = paramOptions || {};
    this.tenant = options.tenant || this.tenant;
    this.model.fetch({ success: () => this.render() });
  },

  go_back() {
    return this.render();
  },

  render() {
    const html = $(
      '#tpl_main',
      template({
        tenant: this.tenant,
      })
    ).html();
    this.$el.html(html);
    $('.carousel', this.$el).carousel();
    this.currentSlide = 0;
    return this;
  },
});
